export const OBSERVERS_PATH = "__observers__";
export const REACTIVE_PATH = "__reactive__";
